const Footer = () => {
    return (
        <div className="footer">
            &copy; Copyright 2026 Rafsan Bari
        </div>
    )
}


export default Footer;